import React from 'react';
import { useSelector } from 'react-redux';

import { EPage, PAGE_PATHNAME } from '@/constants/pages';
import { useRouter } from '@/hooks/useRouter';
import { TRootState } from '@/redux/rootReducer';

import SearchPreviewResults, { TFilterPreviewState } from './SearchPreviewResults';

interface IProps {
  onSubmit?: () => void;
  isDisabled?: boolean;
}

const SearchPreviewResultsContainer: React.FC<IProps> = props => {
  const router = useRouter();
  const isEscapesSearchPage = router?.pathname?.includes(PAGE_PATHNAME[EPage.ESCAPES_SEARCH]);
  const isCampgroundsSearchPage = router?.pathname?.includes(
    PAGE_PATHNAME[EPage.CAMPGROUND_SEARCH],
  );
  const { isMetaLoading, errorMeta, metaPreview } = useSelector<TRootState, TRootState['search']>(
    state => state.search,
  );
  let state: TFilterPreviewState = 'idle';
  let total: number | null = null;

  if (isMetaLoading) state = 'loading';
  if (errorMeta) state = 'error';
  total = metaPreview?.total !== undefined ? metaPreview?.total : null;

  return (
    <SearchPreviewResults
      {...props}
      state={state}
      total={total}
      isEscapesSearchPage={isEscapesSearchPage}
      isCampgroundsSearchPage={isCampgroundsSearchPage}
    />
  );
};

export default SearchPreviewResultsContainer;
